import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQueryWithReauth } from './baseFectch';
export const docsApi = createApi({
  reducerPath: 'docsApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['uploadCompanyDocs', 'getDocs', 'deleteComapnyDoc'],
  endpoints: (builder) => ({
    uploadCompanyDoc: builder.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: '/upload',
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
      invalidatesTags: ['getDocs', 'deleteComapnyDoc'],
    }),
    getCompanyDocs: builder.query<any, any>({
      query: ({ roleName, companyId }) => ({
        url: `/companyPolicies?roleName=${encodeURIComponent(
          roleName
        )}&companyId=${companyId}`,
        method: 'GET',
      }),
      providesTags: ['getDocs'],
    }),

    uploadEmployeeDocs: builder.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: '/upload-additional-docs',
        method: 'POST',
        body: data,
        credentials: 'include',
      }),
      invalidatesTags: ['getDocs', 'deleteComapnyDoc'],
    }),
    renameDocument: builder.mutation<
      any,
      { id: string; fileName: string; name: string }
    >({
      query: ({ id, fileName, name }) => ({
        url: `/documents/${id}/rename`,
        method: 'PATCH',
        body: { fileName, name },
        credentials: 'include',
      }),
      invalidatesTags: ['getDocs'],
    }),
    deleteCompanyDoc: builder.mutation<
      any,
      { fileKey: string | undefined | null }
    >({
      query: ({ fileKey }) => ({
        url: `/deleteDoc/?id=${fileKey}`,
        method: 'DELETE',
        body: fileKey,
        credentials: 'include',
      }),
      invalidatesTags: ['getDocs', 'uploadCompanyDocs'],
    }),
    deleteEmployeeDoc: builder.mutation<
      any,
      { fileKey: string | undefined | null }
    >({
      query: ({ fileKey }) => ({
        url: `/delete-employee-doces?id=${fileKey}`,
        method: 'DELETE',
        body: fileKey,
        credentials: 'include',
      }),
      invalidatesTags: ['getDocs', 'uploadCompanyDocs'],
    }),
  }),
});

export const {
  useLazyGetCompanyDocsQuery,
  useUploadCompanyDocMutation,
  useDeleteCompanyDocMutation,
  useUploadEmployeeDocsMutation,
  useDeleteEmployeeDocMutation,
  useRenameDocumentMutation,
} = docsApi;
